<template>

	<div>

		<div class="container">

			<div class="learning-state-list">
				<ul>

					<li :id="'item-' + item.emIdx" v-for="(item, index) in eduList">
						<a href="javascript:;" @click="goLearn(item)">
							<div class="thumb-box" v-if="item.thumbnail != null && item.thumbnail !== ''" :style="'background-image: url(' + item.thumbnail + ');'"></div>
							<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
							<div class="text-box">
								<div class="cate bedge-line">
									<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
									<span class="sec" v-if="item.isMajor">주요교육</span>
								</div>
								<h2 class="tit">
									{{ item.shortTitle }} {{ item.eduTitle }}
								</h2>
							</div>
							<div class="info-box">
								<div class="info-row info-progress">
									<strong>진행율</strong>
									<div>
										<em :style="'width:' + ( $options.filters.avg( item.completeContentCnt, item.allContentCnt )) + '%;'">
											<span>{{  item.completeContentCnt | avg( item.allContentCnt )  }}%</span>
										</em>
									</div>
								</div>

								<template v-for="( content, i ) in item.contentList">

									<div class="info-row" v-if="content.contentType === 'mov'">
										<strong>영상</strong>
										<div>
											<span class="name">{{content.qstMovVO.movTitle}}</span>
											<span class="num">
												<template v-if="item.studentVO.answerList[i] != null && item.studentVO.answerList[i].ansMovVO != null">
													{{ Math.floor(item.studentVO.answerList[i].ansMovVO.currentTimes / 60) }}분
												</template>
												<template v-else>
													0분
												</template>
												/ {{content.qstMovVO.playMinutes}}분
											</span>
										</div>
									</div>

									<div class="info-row" v-else-if="content.contentType === 'file'" >
										<strong>파일</strong>
										<div>
											<span>
												<template v-if="item.studentVO.answerList[i] != null">
													{{ item.studentVO.answerList[i].fileDownloadCount }}
												</template>
												<template v-else>
													0
												</template>
												/ {{content.qstFileVO.fileList.length}}개
											</span>
										</div>
									</div>

									<div class="info-row" v-else-if="content.contentType === 'tst'" >
										<strong>테스트</strong>
										<div>
											<span>
												<template v-if="item.studentVO.answerList[i] != null">
													{{ item.studentVO.answerList[i].tstSolveCount }}
												</template>
												<template v-else>
													0
												</template>
												/ {{content.qstTstList.length}}문항
											</span>
										</div>
									</div>

								</template>

							</div>
						</a>
					</li>

				</ul>
			</div>


		</div>

	</div>

</template>

<script>

export default {
	name: "eduMineList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		eduList: Array,
	},
	data() {



		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {

	},
	mounted() {

	},
	methods: {


		goLearn( _item ) {
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.emIdx)
			}
			this.$eventBus.$emit("goLearning", _item.emIdx)
		},

	},
}
</script>

<style scoped>

</style>